<template>
  <b-container class="page">
    <loading v-if="loading"></loading>
    <div v-else class="well" style="overflow: auto;">
      <div class="mb-4">
        <h3>Facebook posts of {{ page.name }}</h3>
        <p>Days ago</p>
        <div class="btn-group day-selection" role="group" aria-label="Days ago">
          <b-button
            v-for="day in days"
            :key="day"
            @click="offset = day"
            variant="outline-primary"
            :class="{ active: day === offset}"
          >{{day}}</b-button>
        </div>
      </div>
      <b-list-group>
        <router-link
          v-for="post in page.posts"
          :key="post.id"
          :to="{ name: 'post', params: { pageId: page.id, postId: post.id }}"
        >
          <b-list-group-item>{{ post.title }}</b-list-group-item>
        </router-link>
      </b-list-group>
      <router-link :to="{ name: 'post', params: { pageId: this.$route.params.id, postId: 'all' }}">
        <b-button class="mt-3" variant="outline-primary">Show all comments for this day</b-button>
      </router-link>
    </div>
  </b-container>
</template>

<script>
import PageService from "@/services/PageService.js";
import Loading from "@/components/Loading";

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: true,
      days: [1, 2, 3, 4, 5, 6, 7],
      offset: 1,
      page: null,
      alert: null
    };
  },
  watch: {
    offset() {
      this.getPageData(); // gets called if day of page is changed
    },
    $route() {
      this.alert = null;
    }
  },
  methods: {
    async getPageData() {
      const accessToken = await this.$auth.getTokenSilently();
      PageService.getPage(this.$route.params.id, this.offset, accessToken).then(
        (page => {
          this.$set(this, "page", page);
          this.loading = false;
        }).bind(this)
      );
    },
    updateAlert(alert) {
      this.alert = alert;
      this.$emit("alert", alert);
    }
  },
  created() {
    if (this.$route.params.alert) {
      this.updateAlert(this.$route.params.alert);
    }
    this.getPageData();
  }
};
</script>
